/* eslint-disable react/no-danger */
import React from 'react';
import { CompositionsInterface } from '../../../../interfaces/prescription';
import Text from '../../Text';
import Tooltip from '../../Tooltip';
import * as Styles from './CheckboxStyles';

export interface ItemInterface {
  readonly id: number;
  readonly title: string;
  readonly description: string;
  readonly checked: boolean;
  readonly dispensedLabel?: string;
  readonly unit?: string;
  readonly quantity?: number;
  readonly blockedLabel?: string;
  readonly compositions?: CompositionsInterface;
}

interface Props {
  items: ItemInterface[];
  onClick(item: ItemInterface): void;
}

const Checkbox: React.FC<Props> = ({ items, onClick }: Props) => {
  return (
    <>
      {items.map((item: ItemInterface) => (
        <Styles.Row key={item.id} onClick={() => onClick(item)}>
          <Styles.Icon name="done-fill" checked={item.checked} />
          <div>
            <Styles.Title color="black">
              {item.title}
              {item.quantity || item.unit ? ' - ' : ''}
              {item.quantity !== 0 ? item.quantity : ''}
                &nbsp;
              {item.unit}
            </Styles.Title>

            {item.compositions?.exist && (
              <Styles.CompositionsList
                dangerouslySetInnerHTML={{
                  __html: item.compositions.items,
                }}
              />
            )}

            <Styles.TagContainer>
              { item.dispensedLabel && (
                <Styles.Tag>{item.dispensedLabel}</Styles.Tag>
              )}

              { item.blockedLabel && !item.dispensedLabel && (
                <Tooltip
                  icon={<Styles.IconInfo />}
                  title={item.blockedLabel.toUpperCase()}
                  content="Houve compra on-line do medicamento. Apenas a farmácia responsável
                pela venda poderá fazer o cancelamento da compra ou dispensação do produto"
                >
                  <div className='tooltip_content'>
                    <Styles.Tag className="blocked">{item.blockedLabel}</Styles.Tag>

                    <Styles.IconInfo />
                  </div>
                </Tooltip>
              )}
            </Styles.TagContainer>

            <Text color="black">{item.description}</Text>
          </div>
        </Styles.Row>
      ))}
    </>
  );
};

export default Checkbox;
